import React from 'react';
import { SectionBlock } from './TwoColumnLayout';
import { Dropdown } from './SettingRow';

interface Props {
	onChange: (value: any) => void;
	accountType: string;
	disabled: boolean;
	value: string;
	updating: boolean;
}

const roamingLimitOptions = [
	{ id: 0, value: '0 €' },
	{ id: 10, value: '10 €' },
	{ id: 30, value: '30 €' },
	{ id: 60, value: '60 €' },
	{ id: 100, value: '100 €' },
	{ id: 200, value: '200 €' },
	{ id: 300, value: '300 €' },
	{ id: 400, value: '400 €' },
	{ id: 500, value: '500 €' }
];

const helpUrls: any = {
	consumer: 'https://asiakaspalvelu.moi.fi/hc/fi/articles/360004152172-N%C3%A4in-asetat-laitteeseesi-oikeat-internet-asetukset',
	business: 'https://www.moi.fi/yrityksille/asiakaspalvelu/ukk/nain-asetat-laitteeseesi-oikeat-internet-asetukset'
};

export const RoamingLimitSelect: React.FC<Props> = (props: Props) => {
	return (
		<SectionBlock>
			<Dropdown
				title="Maksullisen dataroamingin käyttöraja"
				disabled={props.disabled}
				updating={props.updating}
				infoText={'Asetusta päivitetään, tämä voi viedä muutaman minuutin'}
				options={roamingLimitOptions}
				selected={props.value}
				onChange={(value: string) => props.onChange({ roamingLimit: { name: 'roamingLimit', value } })}
			>
				<p>Huomio! Tarkasta aina ennen ulkomaille matkustamista, että laitteessasi on oikeat internet-asetukset. Oikea APN-yhteyspiste on data.moimobile.fi</p>
				<a href={helpUrls[props.accountType]} target="_blank">
					Ohjeet asetusten muuttamiseen.
				</a>
			</Dropdown>
		</SectionBlock>
	);
};
